import {AccreditationEventIssuanceCriteriaFields} from "../partials/AccreditationEventIssuanceCriteriaFields";
import {labelValueArrayToObject} from "../../util";
import {FieldSpecRepeater} from "../spec-repeater/FieldSpecRepeater";

const AgencyProfessionCodes = props => {

  const professionCodes = tangibleFields.render({
    type: 'repeater',
    name: 'profession_codes',
    value: props.value.profession_codes,
    layout: 'table',
    sectionTitle: 'Content',
    fields: [{
      type: 'combo-box',
      name: 'id',
      label: 'Profession',
      choices: labelValueArrayToObject( window.tgblCredProfessions )
    }, {
      type: 'text',
      name: 'code',
      label: 'Code'
    }]
  })

  return (
    <div className="tgbl-cred-profession-codes tgbl-field-block">
      <div className="tf-pseudo-description">Custom profession-specific codes for this Agency</div>
      {professionCodes}
    </div>
  )
}

export {AgencyProfessionCodes}
